import React from "react";
import {
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Checkbox,
  Typography,
} from "@material-ui/core";

const OrderPackagesTableHead = ({
  sortField,
  sortDirection,
  handleSort,
  selectedPackages,
  packages,
  handleSelectAll,
  selectedStatus,
}) => {
  const createSortHandler = (field) => () => {
    handleSort(field);
  };

  const isAllSelected =
    selectedPackages.size === packages.length && packages.length > 0;

  return (
    <TableHead>
      <TableRow>
        {/* Select All Checkbox */}
        <TableCell>
          <Checkbox
            disabled={selectedStatus !== "Ready"}
            color="primary"
            checked={isAllSelected}
            onChange={handleSelectAll}
          />
        </TableCell>

        {[
          { label: "Package", field: "id" },
          { label: "Order #", field: "orderId" },
          { label: "Customer", field: "customer" },
          { label: "Box", field: "box" },
          { label: "Label", field: "id" },
          { label: "Status", field: "status" },
        ].map(({ label, field }, index) => (
          <TableCell
            key={index}
            sortDirection={sortField === field ? sortDirection : false}
            style={{ color: "black !important" }}
          >
            <TableSortLabel
              active={sortField === field}
              direction={sortField === field ? sortDirection : "asc"}
              onClick={createSortHandler(field)}
              style={{ color: "black !important" }}
            >
              <Typography variant="body2">{label}</Typography>
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default OrderPackagesTableHead;
